<script>
    export let size = 32
    export let color = '#ffffff'
    export let style = ''
    export let title = null
</script>

<svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    {style}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    {#if title}
        <title>{title}</title>
    {/if}
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.66675 6.6665H29.3334V9.33317H2.66675V6.6665ZM2.66675 14.6665H29.3334V17.3332H2.66675V14.6665ZM29.3334 22.6665H2.66675V25.3332H29.3334V22.6665Z"
        fill={color}
    ></path>
    <mask
        id="mask0_8668_99753"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="6"
        width="28"
        height="20"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.66675 6.6665H29.3334V9.33317H2.66675V6.6665ZM2.66675 14.6665H29.3334V17.3332H2.66675V14.6665ZM29.3334 22.6665H2.66675V25.3332H29.3334V22.6665Z"
            fill={color}
        ></path>
    </mask>
    <g mask="url(#mask0_8668_99753)">
        <rect width={size} height={size} fill={color}></rect>
    </g>
</svg>
